import {SearchTypes, isSearchType} from '@upi/data-layer-constants';
import {normalizeSearchTerm} from '@upi/data-layer-utils';

const SEARCH_ANALYTICS_CONTEXT_KEY = 'upi:search-analytics-context';

function getSessionStorage () {
    try {
        return window.sessionStorage;
    }
    catch ( error ) {
        return null;
    }
}

export function saveSearchAnalyticsContext ( term, searchType ) {
    const storage = getSessionStorage();

    if ( !storage || !isSearchType( searchType ) ) {
        return false;
    }

    try {
        storage.setItem( SEARCH_ANALYTICS_CONTEXT_KEY, JSON.stringify( {
            term: normalizeSearchTerm( term ),
            searchType
        } ) );

        return true;
    }
    catch ( error ) {
        return false;
    }
}

export function consumeSearchAnalyticsContext ( term, fallback = SearchTypes.HEADER ) {
    const storage = getSessionStorage();

    if ( !storage ) {
        return fallback;
    }

    let storedValue;

    try {
        storedValue = storage.getItem( SEARCH_ANALYTICS_CONTEXT_KEY );
        storage.removeItem( SEARCH_ANALYTICS_CONTEXT_KEY );
    }
    catch ( error ) {
        return fallback;
    }

    if ( !storedValue ) {
        return fallback;
    }

    try {
        const context = JSON.parse( storedValue );
        const isMatchingTerm = context.term === normalizeSearchTerm( term );

        return isMatchingTerm && isSearchType( context.searchType ) ? context.searchType : fallback;
    }
    catch ( error ) {
        return fallback;
    }
}

export function getManualSearchType ( {
                                          pathname = window.location.pathname,
                                          isDesktop = !window.matchMedia
                                              || window.matchMedia( '(min-width: 768px)' ).matches
                                      } = {} ) {
    if ( /^\/(search|serach)(\/)?$/i.test( pathname || '' ) ) {
        return SearchTypes.RESULTS_REFINEMENT;
    }

    return isDesktop ? SearchTypes.HEADER : SearchTypes.MOBILE;
}
